import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './assets/css/global.scss';
import 'slick-carousel/slick/slick.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';

import appConfig from './app/config/appConfig';
import {initConfig} from './app/config/config';
import App from './app/containers/App/App';
import log from './app/services/logger/log';
import {addReduxLoggerIfEnabled, configureStore} from './app/state/store';

const render = async () => {
    await initConfig();

    if (appConfig.getIsMarketInitialized()) {
        log.setLevel(appConfig.getLogLevel(), appConfig.getAwsLogLevel());
    }

    const store = configureStore();

    await addReduxLoggerIfEnabled();

    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
};

render();
